import Job, { JobProps } from './_Job';

interface DepartmentProps {
  jobs: Array<JobProps>;
  name: string;
}

const Department = ({ jobs, name }: DepartmentProps) => {
  if (!jobs?.length) return null;

  //This was added not because the data is wrong but HR wants to create multiple job listings
  //in various cities but only have a single job posting show up on the site. It just creates one posting
  //per title and location
  const noRepeatJobs = jobs.filter(
    (job, index, self) =>
      index === self.findIndex((j) => j.location === job.location && j.title === job.title),
  );

  return (
    <div className="tw-flex tw-flex-col tw-align-middle">
      <h4 className="tra-text-web-heading-6 tw-self-center tw-mb-4">{name}</h4>
      <ul className="tw-list-none tw-pl-0 tw-mb-10">
        {noRepeatJobs.map((job) => (
          <Job key={job.title} {...job} />
        ))}
      </ul>
    </div>
  );
};

export default Department;
